import { fmtInt, fmtMoney, totalCreated } from "../usagePeriods";

/**
 * Cabecera de negocio: lo primero que se ve. Cartera (dinero y estado de la base de
 * clientes) y uso del periodo elegido. Cifras grandes con tracking negativo y
 * tabular-nums; texto en tonos de texto, el color solo marca semántica.
 */
function Tile({ label, value, hint, tone, index }) {
  return (
    <div className={`sa-tile ${tone ? `tone-${tone}` : ''}`} style={{ '--i': index }}>
      <span className="sa-tile-label">{label}</span>
      <span className="sa-tile-value">{value}</span>
      {hint && <span className="sa-tile-hint">{hint}</span>}
    </div>
  );
}

export default function BusinessHeader({ portfolio, usage, periodLabel, leadsCount, periodControl }) {
  const t = usage?.totals;
  const created = totalCreated(t);
  const confirmRate = created ? Math.round(((t?.appointmentsConfirmed || 0) / created) * 100) : null;
  const netRevenue = (t?.revenueBooked || 0) - (t?.revenueCancelled || 0);

  return (
    <section className="sa-section sa-kpis">
      <div className="sa-kpi-group">
        <h2 className="sa-eyebrow">Cartera</h2>
        <div className="sa-tiles">
          <Tile index={0} label="MRR" value={fmtMoney(portfolio.mrr)} hint={`${portfolio.active} activo${portfolio.active === 1 ? '' : 's'}`} tone="brand" />
          <Tile index={1} label="Suscripciones" value={`${portfolio.active} · ${portfolio.grace} · ${portfolio.expired}`} hint="activas · gracia · vencidas" tone={portfolio.expired > 0 ? 'warn' : undefined} />
          <Tile index={2} label="WhatsApp vivo" value={`${portfolio.waConnected}/${portfolio.total}`} hint={portfolio.waDown > 0 ? `${portfolio.waDown} caído${portfolio.waDown === 1 ? '' : 's'} pagando` : 'activos conectados'} tone={portfolio.waDown > 0 ? 'danger' : undefined} />
          <Tile index={3} label="Leads 30 d" value={fmtInt(leadsCount)} hint="pidieron código, no terminaron" tone={leadsCount > 0 ? 'info' : undefined} />
        </div>
      </div>
      <div className="sa-kpi-group">
        <div className="sa-kpi-head">
          <h2 className="sa-eyebrow">Uso · {periodLabel}</h2>
          {periodControl}
        </div>
        <div className="sa-tiles">
          <Tile index={4} label="Mensajes recibidos" value={fmtInt(t?.messagesReceived)} hint={`${fmtInt(t?.messagesSent)} enviados por el bot`} />
          <Tile index={5} label="Citas" value={fmtInt(created)} hint={confirmRate === null ? 'sin citas' : `${confirmRate}% confirmación · ${fmtInt(t?.appointmentsCancelled)} canceladas`} />
          <Tile index={6} label="Recordatorios" value={fmtInt(t?.remindersSent)} hint={t?.remindersFailed ? `${fmtInt(t.remindersFailed)} fallidos` : 'sin fallos'} tone={t?.remindersFailed ? 'warn' : undefined} />
          <Tile index={7} label="Valor agendado" value={fmtMoney(netRevenue)} hint="lo que facturan vía TurnLink" tone="brand" />
        </div>
      </div>
    </section>
  );
}
